/* eslint-disable */
<template>
  <b-container fluid class="blackedout presentation_iframe">
    <!-- <vue-pdf-app @pages-rendered="pagesRenderedHandler" :config="config" style="height: 100vh;" pdf="/js/placefiller.pdf"></vue-pdf-app> -->

    <div class="loadingdiv">
      <h2>Loading...</h2>
    </div>
    <!-- <div class="blocker"></div> -->

    <iframe id="presentationIframe" :src="source" allowfullscreen frameborder="0"> </iframe>
  </b-container>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      iframeurl: "",
      source: "",
      serveurl: "",
    };
  },
  mounted() {
    let vm = this;

    vm.iframeurl = vm.$session.get("presid");
    vm.extraction(vm.iframeurl + ".zip", "extracted").then(function () {
      vm.serve().then(function () {
        const iframe = document.getElementById("presentationIframe");
        console.log(`iframe: `, iframe);

        iframe.onload = function () {
          const input = iframe.contentWindow.document.getElementById("statusCurrent");
          if (input) {
            input.disabled = true;
          } else {
            console.error("statusCurrent not found in iframe.");
          }
        };
      });
    });
  },

  methods: {
    async serve() {
      try {
        let vm = this;
        let userPath = await window.file.userPath();
        let filepath = "file:" + userPath + "/extracted/" + vm.iframeurl + ".html";
        vm.source = filepath;
      } catch (e) {
        console.log(`Failed to serve the file ${e}!`);
      }
    },
    async extraction(file, location) {
      try {
        let vm = this;
        await window.file.unzip(file, location);
      } catch (e) {
        console.log(`Failed to unzip the file ${e}!`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
svg.presentationnav {
  width: 60px;
  position: fixed;
  right: 0px;
  height: 50px;
  top: 35px;
  background: black;
  padding: 10px 5px;
}

.blackedout {
  height: 100vh;
}
.loadingdiv {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
